module.exports = __webpack_public_path__ + "media/common/img/bullseye-13e684f084822c44d5edc27b08c9cee1.svg";